
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"18","height":"14","viewBox":"0 0 18 14","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M1.5 3.667L8.075 8.05c.56.373 1.29.373 1.85 0L16.5 3.666M3.167 12.834h11.666c.92 0 1.667-.746 1.667-1.667V2.833c0-.92-.746-1.667-1.667-1.667H3.167c-.92 0-1.667.747-1.667 1.667v8.334c0 .92.746 1.666 1.667 1.666z","stroke":"currentColor","stroke-width":"1.5","stroke-linejoin":"round"}})])
          )
        }
      }
    